import { render, staticRenderFns } from "./locals.vue?vue&type=template&id=4bcde9bf"
import script from "./locals.vue?vue&type=script&lang=js"
export * from "./locals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports